<script lang="ts">
  import { accountHasFeature } from '@/utils'
  import { find } from 'lodash'
  import { fade } from 'svelte/transition'

  let {
    value = $bindable(''),
    coupons = []
  } = $props()

  let selected = $state(value)
  let visible = $state(false)
  let selectedCoupon = $derived.by(() => {
    return find(coupons, coupon => {
      return coupon.id === selected
    })
  })
  let selectedTitle = $derived(!!selectedCoupon ? selectedCoupon.name : 'Attach a Coupon')

  function ok() {
    visible = false
  }

  function cancel() {
    selected = null
    visible = false
  }
</script>

{#if accountHasFeature('coupons')}
  <div class="AttachCouponsList">
    <button type="button" class="btn btn-link btn-link--green px-0" onclick={() => visible = true}>
      <i class="icon icon--add-coupon" class:active={selected}></i>
      {selectedTitle}
    </button>

    {#if visible}
      <div class="attach-coupon-modal" transition:fade>
        <div class="form-group">
          <label for="attach-coupon">Select a Coupon:</label>
          <div class="flex-row">
            <div class="cell-1">
              <select class="form-control" id="attach-coupon" bind:value={selected}>
                <option value="null">(None selected)</option>
                {#each coupons as coupon (coupon.id)}
                  <option value="{coupon.id}">{coupon.name}</option>
                {/each}
              </select>
            </div>
            <div class="cell-0">
              <button type="button" class="btn btn-default" onclick={ok}>OK</button>
              <button type="button" class="btn remove-coupon-btn" onclick={cancel}>×</button>
            </div>
          </div>
        </div>
      </div>
    {/if}
  </div>
{/if}
